module.exports = __webpack_public_path__ + "static/media/200804-artwork-fashion-slashie-tayler.956c5579.jpg";